import get from "lodash/get";
import React, { Component } from "react";
import { withSnackbar } from "notistack";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Button from "@material-ui/core/Button";
import Helmet from "react-helmet";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import Grid from "@material-ui/core/Grid";
import headersList from "../../../../../../Constants/headersList";
import "./exitreasons.css";
import { instance } from "../../../../../../Actions/AxiosInstance";
import { CheckActionPermission } from "../../../../../../Actions/commonAction";
import {
  CreateComp,
  List,
  TDTypeConsts,
} from "../../../../business-configration/commons";
import Create from "./create";
import { ErrorMessages } from "../../../../../../Constants";

class ExitReasons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: false, readonly: false },
      listdata: [],
      termination: {
        headers: [
          {
            key: "reason",
            name: "Termination Reasons",
            style: { textAlign: "left", width: "40%" },
          },
          {
            key: "timesused",
            name: "Times Used",
            type: TDTypeConsts.OTHERS,
          },
          {
            key: "isactive",
            name: "In-use",
            type: TDTypeConsts.STATE_ACTIVE_INACTIVE,
          },
          {
            key: "edit",
            name: "",
            type: TDTypeConsts.EDIT_WITHOUT_HEADER,
            style: { width: "8%" },
          },
          {
            key: "delete",
            name: "",
            type: TDTypeConsts.DELETE_WITHOUT_HEADER,
            style: { width: "8%" },
          },
        ],
        data: [],
      },
      resignation: {
        headers: [
          {
            key: "reason",
            name: "Resignation Reasons",
            style: { textAlign: "left", width: "40%" },
          },
          {
            key: "timesused",
            name: "Times Used",
            type: TDTypeConsts.OTHERS,
          },
          {
            key: "isactive",
            name: "In-use",
            type: TDTypeConsts.STATE_ACTIVE_INACTIVE,
          },
          {
            key: "edit",
            name: "",
            type: TDTypeConsts.EDIT_WITHOUT_HEADER,
            style: { width: "8%" },
          },
          {
            key: "delete",
            name: "",
            type: TDTypeConsts.DELETE_WITHOUT_HEADER,
            style: { width: "8%" },
          },
        ],
        data: [],
      },
    };
    this.onEdit = this.onEdit.bind(this);
    this.getExitReasons = this.getExitReasons.bind(this);
    this._renderList = this._renderList.bind(this);
    this._renderCreate = this._renderCreate.bind(this);
    this._renderEdit = this._renderEdit.bind(this);
    this._onCreate = this._onCreate.bind(this);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("exitReasons");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getExitReasons();
        if (this.props.history.location.pathname.includes("create")) {
          this.props.history.push(`${this.props.match.path}`);
        }
        if (!this.state.permissions.editable) {
          const index = this.termination.headers.findIndex(
            (x) => x.type == TDTypeConsts.EDIT_WITHOUT_HEADER,
          );
          if (index != -1) {
            this.termination.headers.splice(index, 1);
          }
        }
        if (!this.state.permissions.editable) {
          const index = this.state.termination.headers.findIndex(
            (x) => x.type == TDTypeConsts.DELETE_WITHOUT_HEADER,
          );
          if (index != -1) {
            this.state.termination.headers.splice(index, 1);
          }
        }
        if (!this.state.permissions.editable) {
          const index = this.state.resignation.headers.findIndex(
            (x) => x.type == TDTypeConsts.EDIT_WITHOUT_HEADER,
          );
          if (index != -1) {
            this.state.resignation.headers.splice(index, 1);
          }
        }
        if (!this.state.permissions.editable) {
          const index = this.state.resignation.headers.findIndex(
            (x) => x.type == TDTypeConsts.DELETE_WITHOUT_HEADER,
          );
          if (index != -1) {
            this.state.resignation.headers.splice(index, 1);
          }
        }
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  getExitReasons() {
    instance.post("exit/getreason", {}).then((resp) => {
      this.setState({
        editData: null,
        termination: {
          ...this.state.termination,
          data: resp.data.result
            .filter((x) => x.reasontypeid == 2)
            .map((res) => ({
              ...res,
              hideedit: res.isdefault ? true : false,
              hidedelete: res.isdefault ? true : false,
            })),
        },
        resignation: {
          ...this.state.resignation,
          data: resp.data.result
            .filter((x) => x.reasontypeid == 1)
            .map((res) => ({
              ...res,
              hideedit: res.isdefault ? true : false,
              hidedelete: res.isdefault ? true : false,
            })),
        },
      });
    });
  }

  _renderCreate() {
    return (
      <Create
        {...this.props}
        onCreate={true}
        getExitReasons={this.getExitReasons}
      />
    );
  }

  _renderEdit() {
    return (
      <Create
        {...this.props}
        editData={this.state.editData}
        onCreate={false}
        getExitReasons={this.getExitReasons}
      />
    );
  }

  _onCreate() {
    this.setState({ editData: POST_DATA }, () => {
      this.props.history.push(`${this.props.match.path}/create`);
    });
  }

  onEdit(item) {
    instance
      .post("exit/getreason", {
        subscriptionexitreasonid: item.subscriptionexitreasonid,
      })
      .then((result) => {
        if (get(result, "data.result[0]", "")) {
          const data = get(result, "data.result[0]", "");
          this.setState({ editData: data }, () => {
            this.props.history.push(`${this.props.match.path}/edit`);
          });
        }
      });
  }

  onDelete = (item) => {
    if (item && item.timesused && item.timesused != 0) {
      this.props.enqueueSnackbar(ErrorMessages.E1210, { variant: "error" });
      return;
    }
    instance
      .delete("exit/reason", {
        data: {
          subscriptionexitreasonid: item.subscriptionexitreasonid,
        },
      })
      .then(() => {
        this.props.enqueueSnackbar("Deleted successfully", {
          variant: "success",
        });
        this.getExitReasons();
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  onStateStatusChange = (val, row) => {
    // if (row && row.timesused && row.timesused != 0) {
    //   this.props.enqueueSnackbar(ErrorMessages.E1060, { variant: "error" });
    //   return;
    // }
    const data = {
      subscriptionexitreasonid: row.subscriptionexitreasonid,
      isactive: !row.isactive,
    };
    this.props.enqueueSnackbar(ErrorMessages.E1070, {
      variant: "warning",
      action: [
        <Button
          color="inherit"
          size="small"
          onClick={() => {
            instance
              .post("exit/isactive", data)
              .then(() => {
                this.props.enqueueSnackbar(ErrorMessages.E0000, {
                  variant: "success",
                });
                this.getExitReasons();
              })
              .catch((error) => {
                const CommonError = error.response
                  ? error.response.data.error.message
                  : error.message;
                this.props.enqueueSnackbar(CommonError, { variant: "error" });
              });
          }}
        >
          Yes
        </Button>,
        <Button
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  };

  _renderList() {
    return (
      <div>
        {this.state.permissions.editable && (
          <span className="floatright margin20">
            <Button
              variant="contained"
              className="btn btn-primary-md-blue"
              color="primary"
              onClick={this._onCreate}
            >
              Create
            </Button>
          </span>
        )}

        <Grid className="padding20">
          <List
            showOnlyList
            list={this.state.resignation.data}
            permissions={this.state.permissions}
            headers={this.state.resignation.headers}
            onEdit={this.onEdit}
            onDelete={this.onDelete}
            onStateStatusChange={this.onStateStatusChange}
          />
        </Grid>
        <br />
        <Grid className="padding20">
          <List
            showOnlyList
            list={this.state.termination.data}
            permissions={this.state.permissions}
            headers={this.state.termination.headers}
            onEdit={this.onEdit}
            onDelete={this.onDelete}
            onStateStatusChange={this.onStateStatusChange}
          />
        </Grid>
      </div>
    );
  }

  render() {
    const { match } = this.props;
    return (
      <div>
        <IntlProvider locale="en">
          <div className="content-outer-wrapper">
            <Helmet>
              <title>{headersList.Config.ExitReasons.header}</title>
            </Helmet>
            {this.state.permissiondenied ? (
              <div className="position-rel">
                <PermissionDeniedComp />
              </div>
            ) : (
              <Switch>
                <Route exact path={`${match.path}`} render={this._renderList} />
                <Route
                  exact
                  path={`${match.path}/create`}
                  render={this._renderCreate}
                />
                <Route
                  exact
                  path={`${match.path}/edit`}
                  render={this._renderEdit}
                />
                <Redirect from={`${match.path}`} to={`${match.path}`} />
              </Switch>
            )}
          </div>
        </IntlProvider>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SubscriptionInfo: state.SubscriptionInfo,
  loginData: state.AuthenticationAction.login,
  AuthenticationAction: state.AuthenticationAction,
  ExitReasonsReducer: state.ExitReasonsReducer,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withSnackbar(ExitReasons)),
);

const POST_DATA = {
  subscriptionexitreasonid: null,
  reasontypeid: null,
  reason: "",
  subscriptionid: null,
  isactive: null,
};

/*

 _renderList1 = () => {
    return (
      <div className="content-subwrapper margin-bottom-30">
        <div className="content-subwrapper margin-bottom-30 main-profile-outer display-block">
          <Grid item xs={12} style={{ height: 40 }}>
            <Button color="primary" variant="contained" style={{ float: "right" }}>
              Create
            </Button>
          </Grid>
          <Grid>
            <Table style={{ marginTop: 20 }}>
              <TableHead style={{ background: "aliceblue" }}>
                <TableRow>
                  <TableCell style={{ fontSize: 13, fontWeight: "bold" }} align="left">
                    Termination Reasons
                  </TableCell>
                  <TableCell style={{ fontSize: 13, fontWeight: "bold" }} align="center">
                    Times Used
                  </TableCell>
                  <TableCell style={{ fontSize: 13, fontWeight: "bold" }} align="center">
                    State{" "}
                  </TableCell>
                  <TableCell style={{ fontSize: 13, fontWeight: "bold" }} align="center" />
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.termination.data.map(row => (
                  <TableRow key={row.name}>
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                    <TableCell align="center">{row.calories}</TableCell>
                    <TableCell align="center">
                      {row.fat} <UpArrow />{" "}
                    </TableCell>
                    <TableCell align="center" style={{ textAlign: "center", cursor: "pointer" }}>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        onClick={this.handleToggle}
                        //className="cursurpointer"
                      >
                        <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
                      </svg>
                      {this.state.show ? (
                        <Menu id="simple-menu">
                          <MenuItem onClick={this.handleClose}>Edit</MenuItem>
                          <MenuItem onClick={this.handleCldose}>Delete</MenuItem>
                        </Menu>
                      ) : null}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>
          <Grid>
            <Table style={{ marginTop: 20 }}>
              <TableHead style={{ background: "aliceblue" }}>
                <TableRow>
                  <TableCell style={{ fontSize: 13, fontWeight: "bold" }} align="left">
                    Resignation Reasons
                  </TableCell>
                  <TableCell style={{ fontSize: 13, fontWeight: "bold" }} align="center">
                    Times Used
                  </TableCell>
                  <TableCell style={{ fontSize: 13, fontWeight: "bold" }} align="center">
                    State
                  </TableCell>
                  <TableCell style={{ fontSize: 13, fontWeight: "bold" }} align="center" />
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.resignation.data.map(row => (
                  <TableRow key={row.name}>
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                    <TableCell align="center">{row.calories}</TableCell>
                    <TableCell
                      align="center"
                      className={row.fat === "Active" ? "activeheader" : ""}
                    >
                      {row.fat} <UpArrow />{" "}
                    </TableCell>
                    <TableCell align="center" style={{ textAlign: "center", cursor: "pointer" }}>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        onClick={this.handleToggle}
                        //className="cursurpointer"
                      >
                        <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
                      </svg>
                      {this.state.show ? (
                        <Menu id="simple-menu">
                          <MenuItem onClick={this.handleClose}>Edit</MenuItem>
                          <MenuItem onClick={this.handleCldose}>Delete</MenuItem>
                        </Menu>
                      ) : null}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>
        </div>
      </div>
    );
  }
  */
